import Sortable from 'sortablejs';
import toArray from '../helpers/toArray';

const Nestable = {
  create(node, props) {
    this.node = node;
    this.options = props;
    this.groupName = `group-${Math.round(111111 + (Math.random() * 999999))}`;

    this.nestedSortables = toArray(node.querySelectorAll('.nested-sortable'));
    this.nestedSortables.push(node);

    this.nestables = [];

    this.nestedSortables.forEach((nestableElement) => {
      this.nestables.push(new Sortable(nestableElement, {
        group: this.groupName,
        draggable: '.nestable-list__item',
        animation: 150,
        fallbackOnBody: true,
        swapThreshold: 0.7,
        emptyInsertThreshold: 12,
        handle: '.nestable-list__item-handle',
        onEnd: this.onNestingChange.bind(this),
      }));
    });
  },

  /**
   * Callback that is called after a nesting change
   *
   * @return {void}
   */
  onNestingChange() {
    const items = this.listToNestedObject(this.node);
    const data = { items };

    if (typeof this.options.nestableMethod !== 'undefined') {
      data._method = this.options.nestableMethod; // eslint-disable-line no-underscore-dangle
    }

    window.axios.post(this.options.nestableApi, data)
      .then(() => {
        window.toaster.show('Sortering opgeslagen', 3000, 'success');
      })
      .catch((/* err */) => {
        window.toaster.show('Fout bij sorteren', 3000, 'danger');
      });
  },

  listToNestedObject(node) {
    const items = [];

    toArray(node.children).forEach((item) => {
      const list = item.querySelector('.nested-sortable');

      items.push({
        id: item.dataset.id,
        children: list ? this.listToNestedObject(list) : [],
      });
    });

    return items;
  },
};

export default Nestable;
